module.exports = __webpack_public_path__ + "img/icon_cd.ac9b99a8.png";